export const backendURL = new URL(process.env.DASHBOARD_BACKEND_URI!);

export type RecordDeleteResponse<RowType> = {
  success: true;
  deleted: string;
  row?: RowType; // For delete-as-update
  authToken?: string; // TODO: The auth API returns the token like this, it should be returned on the row object
  data?: {
    id: string;
  };
};

export type RecordUpdateResponse<RowType> = {
  success: true;
  updated: string;
  row: RowType;
  authToken?: string; // TODO: The auth API returns the token like this, it should be returned on the row object
};

export type RecordAddResponse<RowType> = {
  success: true;
  created: string;
  row: RowType;
  authToken?: string; // TODO: The auth API returns the token like this, it should be returned on the row object
};

export type RecordDetailResponse<RowType> = {
  success: true;
  row: RowType;
};

export type RecordModificationResponse<RowType> = RecordUpdateResponse<RowType> | RecordAddResponse<RowType> | RecordDeleteResponse<RowType>;

export class RemoteAPIError extends Error {
}

export async function processResponse<T = any>(response: Response): Promise<T> {
  if (response.status === 403) {
    window.location.assign("/login");
    throw new RemoteAPIError("Forbidden");
  }

  if (response.ok) {
    return response.json();
  }

  throw new RemoteAPIError(await response.text());
}
